import React from "react";

export function Worldle() {
  return (
    <span className="font-bold">
      KOMMUND<span className="text-green-600">L</span>E
    </span>
  );
}
